export default __webpack_public_path__ + "static/media/04_2_dissens_ergebnis.80268de8.png";